<style lang='scss'>
// 菜单动画关键帧
@keyframes menuGradient {
  0% { background-position: 0% 50%; }
  50% { background-position: 100% 50%; }
  100% { background-position: 0% 50%; }
}

@keyframes menuItemGlow {
  0%, 100% { 
    box-shadow: inset 0 0 5px rgba(0, 212, 255, 0.2);
  }
  50% { 
    box-shadow: inset 0 0 15px rgba(0, 212, 255, 0.4);
  }
}

@keyframes borderFlow {
  0% { border-top-color: rgba(0, 212, 255, 0.3); border-bottom-color: rgba(0, 212, 255, 0.8); }
  50% { border-top-color: rgba(0, 212, 255, 0.8); border-bottom-color: rgba(0, 212, 255, 0.3); }
  100% { border-top-color: rgba(0, 212, 255, 0.3); border-bottom-color: rgba(0, 212, 255, 0.8); }
}

.menulayout {
  font-family: Segoe UI, Tahoma, Arial, Verdana;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 200;
  padding-top: 90px;
  height: 100%;
  
  // 深色赛博朋克渐变背景
  background: linear-gradient(-45deg, #0a0e27, #1a1f3a, #0d1b2a, #09659A) !important;
  background-size: 400% 400%;
  animation: menuGradient 15s ease infinite;
  
  width: 60px;
  color: rgb(221, 221, 221);
  
  // 右侧发光边框
  border-right: 1px solid rgba(0, 212, 255, 0.3);
  box-shadow: 2px 0 10px rgba(0, 212, 255, 0.2);
  
  // 左侧装饰线
  border-left: 1px solid rgba(0, 212, 255, 0.2);
  
  // 顶部连接效果
  &::before {
    content: '';
    position: absolute;
    top: 50px;
    left: 0;
    right: 0;
    height: 1px;
    background: linear-gradient(90deg, transparent, rgba(0, 212, 255, 0.5), transparent);
  }
  .menutree {
    height: 100%;
    overflow: auto;
    background-color: inherit;
    margin-top: 5px;
    & > li > .vview-treenode-title {
      padding-left: 12px !important;
      font-size: 14px;
      padding-top: 3px;
      padding-bottom: 3px;
    }
    .vview-treenode-title {
      padding-top: 2px;
      padding-bottom: 2px;
      display: flex;
      & > span:not(.vview-treenode-icon) {
        flex-grow: 1;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
  .menuvisible {
    position: absolute;
    right: 0;
    top: 66px;
  }
  .menu-project-header {
    font-weight: bold;
    position: absolute;
    top: 60px;
    left: 12px;
    font-size: 16px;
  }
  .divul {
    position: absolute;
    top: 70px;
    bottom: 0;
    width: 100%;
    overflow: auto;
    
    // 滚动条样式
    &::-webkit-scrollbar {
      width: 4px;
    }
    &::-webkit-scrollbar-track {
      background: rgba(0, 0, 0, 0.2);
    }
    &::-webkit-scrollbar-thumb {
      background: rgba(0, 212, 255, 0.3);
      border-radius: 2px;
      &:hover {
        background: rgba(0, 212, 255, 0.6);
      }
    }
    
    a {
      color: rgba(255, 255, 255, 0.7);
      transition: all 0.3s ease;
      position: relative;
      
      &::before {
        content: '';
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        width: 0;
        height: 2px;
        background: #00d4ff;
        transition: width 0.3s ease;
        box-shadow: 0 0 8px rgba(0, 212, 255, 0.8);
      }
    }
    a:hover,
    a:focus {
      color: #00d4ff;
      text-shadow: 0 0 10px rgba(0, 212, 255, 0.8);
      
      &::before {
        width: 20px;
      }
    }
  }
  .menudetail {
    position: absolute;
    top: 0;
    padding-top: 50px;
    height: 100%;
    min-height: 600px;
    background: #fff;
    z-index: 99999;
    // overflow: auto;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    .submenu-block {
      background: #fff;
      width: 220px;
      border-left: 1px solid #f2f2f2;
    }
    .submenu-title {
      line-height: 40px;
      font-size: 16px;
      color: #171717;
      margin-top: 16px;
      padding: 0 20px;
    }
    .submenu-twotitle {
      line-height: 40px;
      color: #bbb;
    }
    .submenu-content {
      line-height: 30px;
      font-size: 12px;
      a {
        color: #32353a;
        cursor: pointer;
        display: inline-block;
      }
      a:hover,
      a:focus {
        color: #3d91ff;
        background: #fafafa;
      }
    }
  }
  .router-link-exact-active,
  .router-link-active {
    color: #00d4ff !important;
    background: rgba(0, 212, 255, 0.15);
    box-shadow: 
      inset 0 0 15px rgba(0, 212, 255, 0.3),
      0 0 10px rgba(0, 212, 255, 0.4);
    border-radius: 8px;
    border: 1px solid rgba(0, 212, 255, 0.3);
    text-shadow: 0 0 8px rgba(0, 212, 255, 0.6);
  }
  .itemLi {
    margin-bottom: 15px;
    cursor: pointer;
    text-align: center;
    position: relative;
    border-radius: 8px;
    margin-left: 4px;
    margin-right: 4px;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    
    // 图标发光效果
    ::v-deep .vview-treenode-icon {
      transition: all 0.3s ease;
      filter: drop-shadow(0 0 2px rgba(255, 255, 255, 0.3));
    }
  }
  
  .itemLi:hover,
  .itemLi:focus,
  .hoveracitve {
    color: #00d4ff;
    background: rgba(0, 212, 255, 0.15);
    box-shadow: 
      inset 0 0 10px rgba(0, 212, 255, 0.3),
      0 0 15px rgba(0, 212, 255, 0.4);
    border-radius: 8px;
    
    ::v-deep .vview-treenode-icon {
      filter: drop-shadow(0 0 8px rgba(0, 212, 255, 0.8));
      transform: scale(1.1);
    }
  }
  
  .liacitve {
    color: #00d4ff !important;
    background: rgba(0, 212, 255, 0.2);
    box-shadow: 
      inset 0 0 15px rgba(0, 212, 255, 0.4),
      0 0 20px rgba(0, 212, 255, 0.6);
    border-radius: 8px;
    border: 1px solid rgba(0, 212, 255, 0.4);
    
    ::v-deep .vview-treenode-icon {
      filter: drop-shadow(0 0 10px rgba(0, 212, 255, 1));
      animation: menuItemGlow 2s ease-in-out infinite;
    }
  }
  .contain-modal {
    position: fixed;
    top: 0;
    right: 0;
    left: 60px;
    bottom: 0;
    background: rgba(0, 0, 0, 0.25);
    z-index: 9990;
  }
  .oneItem {
    border-bottom: 1px solid #bbb;
  }
  .nav-span {
    width: 10px;
    height: 10px;
    background: #ddd;
    display: inline-block;
    float: left;
    border-radius: 10px;
    margin-left: 5px;
    margin-top: 15px;
  }
  .last-submenu:last-child {
    border-bottom: 1px solid #f1f1f1;
  }
}
.port-menulayout {
  width: 216px;
}
.color-666 {
  color: #666;
}
.color-name {
  color: #32353a;
}
.font-22 {
  font-size: 22px !important;
}
.dropLeftIcon {
  font-size: 22px;
  color: #666;
  position: absolute;
  top: 300px;
  left: 260px;
  z-index: 77889;
}
.dropRightIcon {
  font-size: 22px;
  color: #666;
  position: absolute;
  top: 300px;
  left: 60px;
  z-index: 77889;
}

.not-draggable {
  cursor: no-drop;
}
.font-15 {
  font-size: 15px;
}
</style>


<template>
  <div>
    <section v-if="isPort"
             class="menulayout port-menulayout">
      <h3 class="menu-project-header">{{getModuleTitle}}</h3>
      <vTree :data="createTree"
             class="menutree"
             theme="dark"
             type="menu"
             direction="vertical"
             :key="routeId"
             multiple></vTree>
    </section>
    <section v-else
             class="menulayout"
             @mouseleave="leaveClass()">

      <ul class="divul">
        <li v-for="(items,index) in moduleList"
            :key="index">
          <div v-if="getModuleMap[items.id]"
               class="font-bold itemLi"
               :class="{'liacitve':getModuleId === items.id,'hoveracitve':hoveritemid === items.id}"
               @click="clickItems(items)"
               @mouseover="moveItem(items)">
            <div><span class="iconfont"
                    :class="iconlist[index-1]"></span></div>
            <span v-if="getModuleMap[items.id]"
                  :key="index"
                  :class="[showlangkey=='en'?'font-12':'font-14']">{{$t(items.langKey,{defaultValue:items.title})}}</span>
          </div>
        </li>
      </ul>
      <!-- 收藏的展示 -->
      <Icon type="ios-arrow-dropleft-circle"
            class="cursor-pointer dropLeftIcon"
            @click="hideCebianlan"
            v-if="isCollect1" />
      <Icon type="ios-arrow-dropright-circle"
            class="cursor-pointer dropRightIcon"
            @click="showCebianlan"
            v-if="isCollect2" />
      <!-- 展示收藏列表 -->
      <div class="menudetail"
           style="left: 60px;"
           v-show="showCollect">
        <div class="submenu-block">
          <div class="submenu-title">
            <span class="iconfont icon-biaoqian margin-right-5"></span>
            <span>常用</span>
            <span class="iconfont icon-ziyuan pull-right cursor-pointer margin-right-10"
                  @click="setupTrue = !setupTrue"></span>
          </div>

          <div class="submenu-content">
            <draggable v-model="navTitleLists"
                       @end="dragend"
                       :disabled="!setupTrue">
              <div class="submenu-content"
                   v-for="(item,key) in navTitleLists"
                   :key="item.id"
                   style="max-height:30px">
                <Icon v-if="setupTrue"
                      type="md-close"
                      class="color-name font-15 margin-left-5 margin-right-5"
                      style="cursor:pointer;"
                      @click.native.stop="cancelTitle(item)" />
                <router-link v-if="item.isVue"
                             :class="{'margin-left-25':!setupTrue}"
                             :key="key"
                             :to="getLink(item)"
                             :title="$t(item.langKey,{defaultValue:item.title})"
                             @click.native.stop="handleRoute(item)">{{$t(item.langKey,{defaultValue:item.title})}}
                </router-link>
                <a v-else
                   :class="{'margin-left-25':!setupTrue}"
                   :key="key"
                   :href="getLink(item)"
                   :title="$t(item.langKey,{defaultValue:item.title})"
                   @click.stop="handleRoute(item)">{{$t(item.langKey,{defaultValue:item.title})}}</a>
                <span class="iconfont icon-move-full color-name"
                      style="max-height:28px;vertical-align: middle;float:right;margin-right:5px;cursor:pointer"
                      v-if="setupTrue"></span>
              </div>
            </draggable>
          </div>
        </div>
      </div>
      <!-- 展示侧边栏的内容详情 -->
      <div class="menudetail"
           ref="changeLeftDistance"
           style="left: 280px;"
           v-show="showItems">
        <div class="submenu-block"
             ref="fudom"
             v-for="(item,key) of getModuleMap[itemList.id]"
             :key="key"
             :changeDiv="moveDiv(getModuleMap[itemList.id],itemList.id)">
          <div v-if="item.linklistId">
            <div v-if="item.menuType == 'YES'"
                 class="submenu-title">
              <span class="iconfont icon-biaoqian margin-right-5"></span>
              <span>{{$t(item.langKey,{defaultValue:item.title})}}</span>
            </div>
            <div class="submenu-content"
                 v-for="(json,index) of getThreeMeList(item.linklistId)"
                 :key="index">
              <!-- 如果设置出第四级别 -->
              <div v-if="json.linklistId">
                <div class="submenu-twotitle"
                     style="font-size:14px">
                  <span class="nav-span"></span>
                  <span style="padding:0 5px;">{{$t(json.langKey,{defaultValue:json.title})}}</span>
                </div>
                <div class="submenu-content last-submenu"
                     v-for="(onejson,index) of getThreeMeList(json.linklistId)"
                     :key="index">
                  <span class="nav-span"></span>
                  <router-link v-if="onejson.isVue"
                               :key="key"
                               class="nav-item margin-left-25"
                               :to="getLink(onejson)"
                               @click.native.stop="handleRoute(onejson)">{{$t(onejson.langKey,{defaultValue:onejson.title})}}</router-link>
                  <a v-else
                     :key="key"
                     class="nav-item margin-left-25"
                     :href="getLink(onejson)"
                     @click.stop="handleRoute(onejson)">{{$t(onejson.langKey,{defaultValue:onejson.title})}}</a>
                </div>
              </div>
              <!-- 正常第三级别展示 -->
              <div class="submenu-content"
                   v-else>
                <router-link v-if="json.isVue"
                             :key="key"
                             class="nav-item margin-left-25"
                             :to="getLink(json)"
                             @click.native.stop="handleRoute(json)">{{$t(json.langKey,{defaultValue:json.title})}}</router-link>
                <a v-else
                   :key="key"
                   class="nav-item margin-left-25"
                   :href="getLink(json)"
                   @click.stop="handleRoute(json)">{{$t(json.langKey,{defaultValue:json.title})}}</a>
                <!-- 添加收藏 -->
                <Tooltip content="收藏"
                         placement="top"
                         theme="light"
                         v-if="!showClickCollect(json) && setupTrue"
                         style="max-height:28px;float:right;margin-right:5px">
                  <span class="iconfont color-666 font-22 icon-pushpin cursor-pointer"
                        style="max-height:28px;vertical-align: middle;"
                        @click="addTitle(json)"></span>
                </Tooltip>
                <!-- 取消收藏 -->
                <Tooltip content="取消收藏"
                         placement="top"
                         theme="light"
                         v-if="showClickCollect(json) && setupTrue"
                         style="max-height:28px;float:right;margin-right:5px">
                  <span class="iconfont color-666 icon-shoucang cursor-pointer"
                        style="max-height:28px;vertical-align: middle;"
                        @click="cancelTitle(json)"></span>
                </Tooltip>
              </div>

            </div>
          </div>
        </div>
      </div>

      <div class="contain-modal"
           v-show="showModal"
           @click="clickCloseModal"></div>

    </section>

  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from "vuex";
import Cookies from 'js-cookie'
import { HttpSaveNavMenu } from '../../../service/base';
import draggable from "vuedraggable";

export default {
  components: {
    draggable
  },
  data () {
    return {
      isPort: false,
      path: null,
      screenHeight: '',
      diivheight: '',
      itemList: [],
      // 从localstorage获取
      showCollect: false,
      showModal: false,
      showItems: false,
      isActive: false,
      hoveritemid: null,
      showlangkey: 'zh-CN',
      newarrMouldMap: [],
      iconlist: ['icon-xiaoshoudingdan', 'icon-kucunguanli', 'icon-caigouguanli', 'icon-chanpinguanli', 'icon-yunyingjiankong', 'icon-hexiaomingxibaobiao', 'icon-cangchu-', 'icon-yunshu-', 'icon-xiangmujiesuanguanli', 'icon-kehuguanli', 'icon-xitongguanli', 'icon-dayin', 'icon-caiwu', 'icon-yewufengkong'],
      tabRoutes: Cookies.get("TABNAVLIST") ? JSON.parse(Cookies.get("TABNAVLIST")) : [],
      checked: [],
      setupTrue: false,
      isCollect1: false,
      isCollect2: false,
      dragging: false,
      navTitleLists: [],
      globalDivId: null,
    };
  },
  created () {
    if (location.host.indexOf('port.') >= 0) {
      this.isPort = true;
    }
    this.path = this.$route.path;
    this.showlangkey = Cookies.get('lang');

  },
  mounted () {
    // console.log('moduleList', this.moduleList);
    // console.log('getModuleMap', this.getModuleMap);
    this.bus.$on("changelang", value => {
      // console.log(value)
      setTimeout(() => {
        this.showlangkey = value
      }, 600)

    });

    window.onresize = () => {
      this.moveDiv()
    }
    this.bus.$on("changemenu", value => {
      this.showNavTitles();
    })
  },
  computed: {
    ...mapState(["staticMenulist"]),
    ...mapGetters(["getStaticMenulist"]),
    ...mapState("layout", ["routeId", "moduleList", 'navTitleIds']),
    ...mapGetters("layout", ["getMenuList", 'getNavTitle', 'getModuleMap']),

    //获取当前模块id
    // 拿到侧边数据，再次重新排序

    getModuleId () {
    //   console.log(this.getMenuList,'getMenuListgetMenuListgetMenuList')
      const getModuleId = routeId => {
        const { moduleId, parentId } = this.getMenuList[routeId] || {};
        if (moduleId || !parentId) return moduleId;
        return getModuleId(parentId);
      };
    //   console.log(this.routeId , getModuleId(this.routeId),this.getModuleMap)
    //   console.log(getModuleId(this.routeId))
      return (this.routeId && getModuleId(this.routeId));
    },
    //获取默认的模块id
    getDefaultModuleId () {
      let moduleId = 0;
      Object.values(this.getMenuList).some((item) => {
        if (item.isVue && item.moduleId) {
          // console.log(item)
          moduleId = item.moduleId
          return true;
        }
      })
      return moduleId;
    },
    getModuleTitle () {

      const obj = this.moduleList[this.getModuleId] || {};
      return this.$t(obj.langKey, { defaultValue: obj.title });
    },
    /**
     * 获取根级模块菜单
     */
    getModuleRoot () {
      const moduleRoot = [],
        moduleId = this.getModuleId,
        menuList = this.getMenuList;
      Object.values(menuList).forEach(function (item) {
        const parent = this[item.parentId] || {};
        // moduleId=0时，仅显示本项目菜单
        if (!moduleId && item.isVue && !parent.isVue) {
          return moduleRoot.push({ ...item });
        }
        if (moduleId && item.moduleId == moduleId && parent.moduleId != moduleId) moduleRoot.push({ ...item });
      }, menuList);
      return moduleRoot.sort(function (pre, next) {
        return next.sortIndex < pre.sortIndex ? 1 : -1;
      });
    },
    createTree () {
      if (this.staticMenulist) {
        const lang = this.$store.state.lang;
        return this.getStaticMenulist.map((item) => {
          return {
            ...item,
            title: item.title[lang]
          }
        })
      }
      const menuList = this.getMenuList,
        moduleRoot = this.getModuleRoot,
        moduleId = this.getModuleId,
        path = this.path,
        iterator = (node) => {
          const { linklistId, id, props = {}, langKey } = node;
          node.title = this.$t(langKey, { defaultValue: node.title });
          if (linklistId) {
            linklistId.forEach(function (id) {
              const item = { ...menuList[id] }
              if (item.moduleId && item.moduleId != moduleId) return;
              iterator(item);
              // node.expand = node.expand || item.expand;
              node.expand = true;
              node.props = null;
              if (node.children) {
                node.children.push(item);
              } else {
                node.children = [item];
              }
            });
          }
          // else {
          // 	// node.expand = path.indexOf(props.to) == 0;
          // }
        };
      moduleRoot.forEach(function (item) {
        iterator(item);
      });
      return [...moduleRoot];
    }
  },
  methods: {
    ...mapMutations('layout', ['setRouteId', 'setNavTitleIds']),
    ...mapState(['userinfo']),

    // 侧边移动收藏
    showNavTitles () {
      this.navTitleLists = this.getNavTitle.concat();
      // console.log(23423,this.navTitleLists)
    },
    dragend (e) {
      // console.log(this.navTitleLists,'getNavTitlegetNavTitle');

      const ids = [];
      this.navTitleLists.map(item => {
        ids.push(item.id)
      })
      // console.log(ids)
      HttpSaveNavMenu({ resourceIds: ids }).then(res => {
        this.$VMessage.success('移动成功！');

        // 重新取值
        this.setNavTitleIds(ids);

        // this.cancel();
      }).catch(err => {
        this.$VMessage.error(err.message);
      })
    },

    /**
     * 获取默认路由数据
     * @param {*} state
     * @param {*} getters
     */
    getRouteData (data) {
      const { linklistId = [], moduleId } = data,
        menuList = this.getMenuList;
      if (linklistId) {
        const getChildRouteId = function (linklistId, moduleId) {
          return linklistId.reduce((pre, cur, index, arr) => {
            if (pre) return pre;
            const routeData = menuList[cur];
            const _moduleId = routeData.moduleId;
            const hasModuleId = !_moduleId || _moduleId == moduleId;
            if (!hasModuleId) return;
            if (routeData.linklistId) {
              return getChildRouteId(routeData.linklistId, moduleId);
            }
            return cur;
          }, null)
        }
        const routeId = getChildRouteId(linklistId, moduleId)
        if (routeId) data = menuList[routeId];
      }
      // console.log(data,'12312312312')
      return data;
    },
    getThreeMeList (moduid) {
      // console.log(moduid,'111')
      if (!moduid) return;
      let menuList = this.getMenuList
      let arr = [];
      Object.keys(menuList).forEach(function (key) {
        // console.log(key)
        moduid.forEach(function (id) {
          if (menuList[key].id === id) {
            arr.push(menuList[key])
          }
        })
      });
      arr = arr.sort(this.compareAttribute('sortIndex'))
      return arr;
    },

    handleRoute (data) {
    //   console.log(data,'23444444444444444444534----------------')
          this.setRouteId(data.id);
      const { isVue, id } = this.getRouteData(data);
      if (isVue) {
          this.$nextTick(() => {
          this.clickCloseModal()
        })
      }
      // 判断路由是否在tabs中，不在则添加进入tabs
      let jsondata = {
        name: data.title,
        path: data.isVue ? data.props.to : data.props.href,
        mouid: data.id,
        isVue: data.isVue,
        userId: this.userinfo.id
      }
      const jsonone = this.tabRoutes.findIndex(item => item.path === jsondata.path);
      // console.log(jsonone)
      if (jsonone > -1) {
        return
      } else {
        this.tabRoutes.push(jsondata)
        Cookies.set('TABNAVLIST', JSON.stringify(this.tabRoutes), { domain: global.DOMAIN, expires: 7 });
        this.bus.$emit("changetablelist", 1);
      }

    },
    moveDiv (val, itemId) {
    //   console.log(itemId, this.showItems)
      //未显示 或者 已显示但同一个id 不执行计算
    //   if (!this.showItems || this.globalDivId === itemId) {
    //     return;
    //   }
      if (!this.showItems) {
        return;
      }
      //记录当前id
      this.globalDivId = itemId;

      let windowHeight = window.innerHeight > 600 ? window.innerHeight : 600
      this.$nextTick(() => {
        for (let i = 0; i < this.$refs.fudom.length; i++) {
          this.$refs.fudom[i].style = "flex:none"
        }
        let sum = 0;
        let widthNum = 0;
        for (let i = 0; i < this.$refs.fudom.length; i++) {
          sum += this.$refs.fudom[i].offsetHeight;
        //   console.log(sum, i, '----------')

          // sum大于屏幕高度
          if (sum >= windowHeight - 50) {
            widthNum++;
            //前i-1已满足条件，窗口累计sum重置，从i开始,sum为记录box的高度
            sum = this.$refs.fudom[i].offsetHeight;
            //0时候避免i-1为-1越界，直接走下一次循环
            if (i == 0) {
              continue;
            }
            //将前一个i-1设为flex1
            this.$refs.fudom[i - 1].style = "flex:1";
            // console.log(i - 1, 'set flex 1')
          }
          //最后一个必须设flex1
          if (i == (this.$refs.fudom.length - 1)) {
            widthNum++;
            this.$refs.fudom[this.$refs.fudom.length - 1].style = "flex:1";
            // console.log(this.$refs.fudom.length - 1, 'last set flex 1')
          }
        }

        // console.log(widthNum, 'widthNum')

        // if (sum == windowHeight - 50) {
        //     // console.log(111111111)
        //     return
        // }
        // 最后一个必加flex
        // // else {
        //     console.log(this.$refs.fudom[this.$refs.fudom.length - 1].style,2222222222)
        //     this.$refs.fudom[this.$refs.fudom.length - 1].style = "flex:1";
        //      console.log(this.$refs.fudom[this.$refs.fudom.length - 1].style,33333)
        //      console.log(this.$refs.fudom[this.$refs.fudom.length - 1].style ==  "flex:1",3333344)
        // }
        return
      }, 300)
    },
    // 点击侧边栏页面跳转
    getLink (data) {
      const { isVue, props = {} } = this.getRouteData(data);
    //   console.log(data)
      return isVue ? props.to : props.href;
    },
    clickItems (onedata) {
      // 点击侧边栏主题栏关闭
      // console.log(this.showItems)

      // console.log(this.showCollect,'456457656785678')

      if (localStorage.getItem('SHOWCOLLECT') == false) {
        this.showCollect = false;
        this.isCollect1 = false;
        this.isCollect2 = true;
        this.afterCollect();
      } else {
        this.showCollect = true;
        this.isCollect1 = true;
        this.isCollect2 = false;
        this.beforeCollect();
      }

      if (this.showItems == true) {
        this.showItems = false;
        this.showModal = false;
        this.showCollect = false;
        this.isCollect1 = false;
        this.isCollect2 = false;

      } else {
        this.showItems = true
        this.showModal = true
      }
    },
    moveItem (list) {
      this.hoveritemid = list.id
      this.itemList = list;

    },
    leaveClass () {
      this.hoveritemid = null
    },
    // 点击外部的背景框
    clickCloseModal () {

      this.showModal = false;
      this.showItems = false;
      this.showCollect = false;
      this.isCollect1 = false;
      this.isCollect2 = false;
    },
    addMyTreasure () {
      this.bus.$emit("changetreasure", 'showtreasure');
    },
    // 展示是否为收藏
    showClickCollect (json) {
      const jsonid = this.navTitleIds.some(id => id === json.id);
      // console.log(jsonid,'jsonidjsonidjsonid')
      return jsonid;
    },
    // 点击添加收藏与取消收藏
    addTitle (json) {
      // this.checked = [...this.navTitleIds].filter(id => this.getMenuList[id]);
      this.checked = [...this.navTitleIds].filter(id => this.getMenuList[id]);
      this.checked.push(json.id)
      const ids = this.checked;

      HttpSaveNavMenu({ resourceIds: ids.join(',') }).then(res => {
        this.$VMessage.success('操作成功，请到 常用 查看！');

        // 重新取值
        this.setNavTitleIds(ids);
        this.showNavTitles();

        // this.cancel();
      }).catch(err => {
        this.$VMessage.error(err.message);
      })
    },
    cancelTitle (json) {
      // console.log(json,'23423432')
      this.checked = [...this.navTitleIds].filter(id => this.getMenuList[id]);
      const nowindex = this.checked.findIndex(item => item === json.id);
      this.checked.splice(nowindex, 1)
      const ids = this.checked;


      HttpSaveNavMenu({ resourceIds: ids.join(',') }).then(res => {
        this.$VMessage.success('操作成功');

        // 重新取值
        this.setNavTitleIds(ids);
        this.showNavTitles();

        // this.cancel();
      }).catch(err => {
        this.$VMessage.error(err.message);
      })
    },
    hideCebianlan () {
      this.isCollect1 = false;
      this.isCollect2 = true;
      this.showCollect = false;
      localStorage.setItem('SHOWCOLLECT', false);
      this.afterCollect()
    },
    showCebianlan () {
      this.isCollect1 = true;
      this.isCollect2 = false;
      this.showCollect = true;
      localStorage.setItem('SHOWCOLLECT', true);
      this.beforeCollect()
    },
    // 关闭收藏之后的逻辑
    afterCollect () {
      this.$refs.changeLeftDistance.style = "left:60px"
    },
    // 关闭之前
    beforeCollect () {
      this.$refs.changeLeftDistance.style = "left:280px"
    },
  }
};
</script>
